import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Measurement"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postMeasurementGet: build.query<
        PostMeasurementGetApiResponse,
        PostMeasurementGetApiArg
      >({
        query: (queryArg) => ({
          url: `/Measurement/Get`,
          method: "POST",
          body: queryArg.body,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            measuringPoint: queryArg.measuringPoint,
            manufacturer: queryArg.manufacturer,
            dataClass: queryArg.dataClass,
          },
        }),
        providesTags: ["Measurement"],
      }),
      postMeasurementGetFirstLastTimestamp: build.query<
        PostMeasurementGetFirstLastTimestampApiResponse,
        PostMeasurementGetFirstLastTimestampApiArg
      >({
        query: (queryArg) => ({
          url: `/Measurement/GetFirstLastTimestamp`,
          method: "POST",
          body: queryArg.body,
          params: {
            manufacturer: queryArg.manufacturer,
            dataClass: queryArg.dataClass,
          },
        }),
        providesTags: ["Measurement"],
      }),
      postMeasurementGetLog: build.query<
        PostMeasurementGetLogApiResponse,
        PostMeasurementGetLogApiArg
      >({
        query: (queryArg) => ({
          url: `/Measurement/GetLog`,
          method: "POST",
          body: queryArg.body,
          params: {
            manufacturer: queryArg.manufacturer,
            dataClass: queryArg.dataClass,
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["Measurement"],
      }),
      postMeasurementGetLogForIntermittentDataClasses: build.query<
        PostMeasurementGetLogForIntermittentDataClassesApiResponse,
        PostMeasurementGetLogForIntermittentDataClassesApiArg
      >({
        query: (queryArg) => ({
          url: `/Measurement/GetLogForIntermittentDataClasses`,
          method: "POST",
          body: queryArg.body,
          params: {
            manufacturer: queryArg.manufacturer,
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["Measurement"],
      }),
      getMeasurementGetPqEvent: build.query<
        GetMeasurementGetPqEventApiResponse,
        GetMeasurementGetPqEventApiArg
      >({
        query: (queryArg) => ({
          url: `/Measurement/GetPQEvent`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            measuringPoint: queryArg.measuringPoint,
          },
        }),
        providesTags: ["Measurement"],
      }),
      getMeasurementPqStatus: build.query<
        GetMeasurementPqStatusApiResponse,
        GetMeasurementPqStatusApiArg
      >({
        query: () => ({ url: `/Measurement/PQStatus` }),
        providesTags: ["Measurement"],
      }),
      getMeasurementPqStatusGroup: build.query<
        GetMeasurementPqStatusGroupApiResponse,
        GetMeasurementPqStatusGroupApiArg
      >({
        query: () => ({ url: `/Measurement/PQStatusGroup` }),
        providesTags: ["Measurement"],
      }),
      getMeasurementPqStatusMeasuringPoint: build.query<
        GetMeasurementPqStatusMeasuringPointApiResponse,
        GetMeasurementPqStatusMeasuringPointApiArg
      >({
        query: () => ({ url: `/Measurement/PQStatusMeasuringPoint` }),
        providesTags: ["Measurement"],
      }),
      getMeasurementPqStatusByInterval: build.query<
        GetMeasurementPqStatusByIntervalApiResponse,
        GetMeasurementPqStatusByIntervalApiArg
      >({
        query: (queryArg) => ({
          url: `/Measurement/PQStatus/${queryArg.interval}`,
          params: { eventType: queryArg.eventType },
        }),
        providesTags: ["Measurement"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as measurementApi };
export type PostMeasurementGetApiResponse = /** status 200 OK */ any[];
export type PostMeasurementGetApiArg = {
  start: string;
  end: string;
  measuringPoint: string;
  manufacturer: string;
  dataClass: string;
  body: string;
};
export type PostMeasurementGetFirstLastTimestampApiResponse =
  /** status 200 OK */ FirstAndLastTimeStampDto | /** status 204 No Content */ void;
export type PostMeasurementGetFirstLastTimestampApiArg = {
  manufacturer: string;
  dataClass: string;
  body: string;
};
export type PostMeasurementGetLogApiResponse =
  /** status 200 OK */ MeasurementLogDto[];
export type PostMeasurementGetLogApiArg = {
  manufacturer: string;
  dataClass: string;
  start?: string;
  end?: string;
  body: string;
};
export type PostMeasurementGetLogForIntermittentDataClassesApiResponse =
  /** status 200 OK */ MeasurementLogDto[];
export type PostMeasurementGetLogForIntermittentDataClassesApiArg = {
  manufacturer: string;
  start?: string;
  end?: string;
  body: string;
};
export type GetMeasurementGetPqEventApiResponse =
  /** status 200 OK */ PqEventExtendedDto[];
export type GetMeasurementGetPqEventApiArg = {
  start: string;
  end: string;
  measuringPoint?: string;
};
export type GetMeasurementPqStatusApiResponse =
  /** status 200 OK */ PqStatusDto[];
export type GetMeasurementPqStatusApiArg = void;
export type GetMeasurementPqStatusGroupApiResponse =
  /** status 200 OK */ PqStatusGroupDto[];
export type GetMeasurementPqStatusGroupApiArg = void;
export type GetMeasurementPqStatusMeasuringPointApiResponse =
  /** status 200 OK */ PqStatusMeasuringPointDto[];
export type GetMeasurementPqStatusMeasuringPointApiArg = void;
export type GetMeasurementPqStatusByIntervalApiResponse =
  /** status 200 OK */ PqSingleStatusDto[];
export type GetMeasurementPqStatusByIntervalApiArg = {
  interval: PqStatusInterval;
  eventType?: string;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type FirstAndLastTimeStampDto = {
  firstTimeStamp: number;
  lastTimeStamp: number;
};
export type MeasurementLogDto = {
  id: number;
  measuringPoint: string;
  dataClassId: number;
  dataClassName: string;
  start: number;
  end: number;
  triggerTime?: number | null;
};
export type PqEventExtendedDto = {
  id: number;
  measuringPoint: string;
  start: number;
  end: number;
  description: string;
  phase?: string | null;
  harmonic?: string | null;
  intervalStart?: string | null;
  intervalEnd?: string | null;
  unit?: string | null;
  data?: number | null;
  type: string;
  status: number;
  dataField?: string | null;
  dataFieldCategory?: string | null;
};
export type PqStatusDto = {
  description: string;
  statusLastDay: number;
  statusLastMonth: number;
  statusLastYear: number;
};
export type PqStatusGroupDto = {
  measuringPointGroupTypeId: number;
  measuringPointGroupTypeName: string;
  measuringPointGroupId: number;
  measuringPointGroupName: string;
  statusLastDay: number;
  statusLastMonth: number;
  statusLastYear: number;
};
export type PqStatusMeasuringPointDto = {
  measuringPoint: string;
  statusLastDay: number;
  statusLastMonth: number;
  statusLastYear: number;
};
export type PqSingleStatusDto = {
  measuringPoint: string;
  status: number;
};
export type PqStatusInterval = "OneDay" | "OneMonth" | "OneYear";
export const {
  usePostMeasurementGetQuery,
  useLazyPostMeasurementGetQuery,
  usePostMeasurementGetFirstLastTimestampQuery,
  useLazyPostMeasurementGetFirstLastTimestampQuery,
  usePostMeasurementGetLogQuery,
  useLazyPostMeasurementGetLogQuery,
  usePostMeasurementGetLogForIntermittentDataClassesQuery,
  useLazyPostMeasurementGetLogForIntermittentDataClassesQuery,
  useGetMeasurementGetPqEventQuery,
  useLazyGetMeasurementGetPqEventQuery,
  useGetMeasurementPqStatusQuery,
  useLazyGetMeasurementPqStatusQuery,
  useGetMeasurementPqStatusGroupQuery,
  useLazyGetMeasurementPqStatusGroupQuery,
  useGetMeasurementPqStatusMeasuringPointQuery,
  useLazyGetMeasurementPqStatusMeasuringPointQuery,
  useGetMeasurementPqStatusByIntervalQuery,
  useLazyGetMeasurementPqStatusByIntervalQuery,
} = injectedRtkApi;
